import React from "react";
import { useQuery } from "@apollo/react-hooks";
import lookup from "country-code-lookup";

import Layout from "components/Layout";
import DataTable, { formatData } from "components/DataTable";
import GeoChart from "components/chart/GeoChart";
import Scrollable from "components/Scrollable";
import Flag from "components/Flag";
import withAuth from "components/withAuth";
import { H2, Section } from "styles";
import { COUNTRY } from "queries";

function Country() {
  const { data: { countries } = { countries: [] } } = useQuery(COUNTRY);

  const format = (item: string) => <Flag item={item} />;

  const data = formatData(countries, false, format);

  const countryData = Object.entries(countries).map(([country, count]: any) => [
    lookup.byIso(country).country,
    count,
  ]);

  countryData.unshift(["Country", "Count"]);

  return (
    <Layout>
      <Section>
        <H2>Contacts by Country</H2>
        <DataTable
          headers={["", "Country", "Count"]}
          data={data}
          link="/contact/country/"
        />
      </Section>
      <Section>
        <H2>Geo Chart</H2>
        <Scrollable>
          <GeoChart data={countryData} />
        </Scrollable>
      </Section>
    </Layout>
  );
}

export default withAuth(Country);
